var map = {
	"./simpleWorker": 5585,
	"./simpleWorker.js": 5585,
	"monaco-editor/esm/vs/base/common/worker/simpleWorker": 5585,
	"monaco-editor/esm/vs/base/common/worker/simpleWorker.js": 5585
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5890;
module.exports = webpackAsyncContext;